import { ApolloFilter } from './apollo-filter.model';
import { File } from '@core/objects/file';

export class ApolloItem {
    public id_file:any = null;
    public page_selected: number;
    public filters: ApolloFilter[] = [];
}
